import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutPreview from "./sections/AboutPreview";
import ServicesOverview from "./sections/ServicesOverview";
import FacilitiesShowcase from "./sections/FacilitiesShowcase";
import Testimonials from "./sections/Testimonials";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutPreview />
      <ServicesOverview />
      <FacilitiesShowcase />
      <Testimonials />
      <CallToAction />
      <Footer />
    </div>;
}